import { render, staticRenderFns } from "./FormMultiCategory.vue?vue&type=template&id=55a3eec6&scoped=true&"
import script from "./FormMultiCategory.vue?vue&type=script&lang=js&"
export * from "./FormMultiCategory.vue?vue&type=script&lang=js&"
import style0 from "./FormMultiCategory.vue?vue&type=style&index=0&id=55a3eec6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3eec6",
  null
  
)

export default component.exports